//Year End Period Action Types

// Get Year End Period List
export const GET_YEAR_END_PERIOD_LIST = "GET_YEAR_END_PERIOD_LIST";
export const GET_YEAR_END_PERIOD_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_LIST_FAILURE";

// Get Year End Period Details
export const GET_YEAR_END_PERIOD_DETAILS = "GET_YEAR_END_PERIOD_DETAILS";
export const GET_YEAR_END_PERIOD_DETAILS_SUCCESS =
  "GET_YEAR_END_PERIOD_DETAILS_SUCCESS";
export const GET_YEAR_END_PERIOD_DETAILS_FAILURE =
  "GET_YEAR_END_PERIOD_DETAILS_FAILURE";

// Update Year End Period Details
export const UPDATE_YEAR_END_PERIOD_DETAILS = "UPDATE_YEAR_END_PERIOD_DETAILS";
export const UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS =
  "UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS";
export const UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE =
  "UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE";

// Create Year End Period
export const CREATE_YEAR_END_PERIOD = "CREATE_YEAR_END_PERIOD";
export const CREATE_YEAR_END_PERIOD_SUCCESS = "CREATE_YEAR_END_PERIOD_SUCCESS";
export const CREATE_YEAR_END_PERIOD_FAILURE = "CREATE_YEAR_END_PERIOD_FAILURE";

// Delete Year End Period
export const DELETE_YEAR_END_PERIOD = "DELETE_YEAR_END_PERIOD";
export const DELETE_YEAR_END_PERIOD_SUCCESS = "DELETE_YEAR_END_PERIOD_SUCCESS";
export const DELETE_YEAR_END_PERIOD_FAILURE = "DELETE_YEAR_END_PERIOD_FAILURE";

// Year End Period invoice List
export const GET_YEAR_END_PERIOD_INVOICE_LIST =
  "GET_YEAR_END_PERIOD_INVOICE_LIST";
export const GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE";

// Year End Period Invoice Items List
export const GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST =
  "GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST";
export const GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE";

// Year End Period Purchase List
export const GET_YEAR_END_PERIOD_PURCHASE_LIST =
  "GET_YEAR_END_PERIOD_PURCHASE_LIST";
export const GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE";

// Year End Period Purchase Items List
export const GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST =
  "GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST";
export const GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE";

// Year End Period Purchase Items List
export const GET_YEAR_END_PERIOD_VAT_LIST = "GET_YEAR_END_PERIOD_VAT_LIST";
export const GET_YEAR_END_PERIOD_VAT_LIST_SUCCESS =
  "GET_YEAR_END_PERIOD_VAT_LIST_SUCCESS";
export const GET_YEAR_END_PERIOD_VAT_LIST_FAILURE =
  "GET_YEAR_END_PERIOD_VAT_LIST_FAILURE";
